import { Box } from "@mui/material";
import ChatHeader from "../ChatHeader/ChatHeader";
import Chat from "../../../../../pages/Chat/Chat";
import { IEventDetailMessages, iEventType } from "../../../../../types/eventTypes";
import { useAppSelector } from "../../../../../hooks/storeHooks";
import { getStringsFirstLetter } from "../../../../../utils/commonUtils";
import { SendbirdUIKitProvider } from "../../../../SendBird/SendbirdUIKitProvider";
import { defaultSendbirdGroupChannelUikitOptions } from "../../../../../constants/sendbirdConstants";
import "./sendbirdChatContainerB2C.scss";

interface ISendbirdChatContainerProps {
	selectedChat: IEventDetailMessages;
	vendorSendBirdId?: string | null;
	showWhatsAppIcon: boolean;
	showWhatsAppBanner: boolean;
	className?: string;
	expanded?: boolean;
	showChatHeaderBackButton?: boolean;
  eventDetail: iEventType;
	isMobile?: boolean;
	onSendChat: () => void;
	setWhatsAppModalOpen: (open: boolean) => void;
	handleCloseChatClick: () => void;
	setDeclineEventModalState: (open: boolean) => void;
	handleSendbirdMessageUpdates: () => void;
	setWhatsappBannerVisible: (value: boolean) => void;
}

const SendbirdChatContainerB2C = ({
	selectedChat,
	vendorSendBirdId,
	showWhatsAppIcon,
	showWhatsAppBanner,
	setWhatsAppModalOpen,
	handleCloseChatClick,
	setDeclineEventModalState,
	handleSendbirdMessageUpdates,
	className,
	setWhatsappBannerVisible,
	expanded,
	showChatHeaderBackButton = true,
	eventDetail,
	isMobile = false,
	onSendChat,
}: ISendbirdChatContainerProps) => {
	const { userDetails } = useAppSelector((state) => state.user);

	if (!selectedChat?.channelUrl) {
		return null;
	}

	const isNewModelChannel = selectedChat.isNewModelChannel === true;

	return (
		<Box
			className={`eventChatContainer ${className || ""} ${expanded ? "eventChatContainer__expanded" : ""}`}
		>
			<ChatHeader
				vendorName={userDetails?.firstName || ""}
				vendorLogo={userDetails?.logo || ""}
				initials={getStringsFirstLetter(userDetails?.firstName, userDetails?.lastName) || ""}
				vendorEventStatus={eventDetail?.vendorStatus}
				whatsAppIconVisible={showWhatsAppIcon}
				onSocialClick={() => setWhatsAppModalOpen(true)}
				onBackClick={handleCloseChatClick}
				showBackButton={showChatHeaderBackButton}
				onCancelEventClick={() => setDeclineEventModalState(true)}
				eventDetail={eventDetail}
				isMobile={isMobile}
			/>
			<SendbirdUIKitProvider
				isNewModelChannel={isNewModelChannel}
				vendorSendBirdId={vendorSendBirdId}
				channelUrl={selectedChat.channelUrl}
				className="eventChatSendbirdProvider"
				uikitOptions={{
					groupChannel: defaultSendbirdGroupChannelUikitOptions,
				}}
			>
				<Chat
					chanelUrl={selectedChat?.channelUrl || ""}
					isWhatsappGroupCreated={selectedChat?.isWhatsappGroupCreated}
					showWhatsAppBanner={showWhatsAppBanner}
					handleShowWhatsAppModal={() => setWhatsAppModalOpen(true)}
					handleShowWhatsAppBanner={setWhatsappBannerVisible}
					isCorporateEvent={false}
					handleSendbirdMessageUpdates={handleSendbirdMessageUpdates}
					onSendChat={onSendChat}
				/>
			</SendbirdUIKitProvider>
		</Box>
	);
};

export default SendbirdChatContainerB2C;
